import { render } from "./our-home-base-hero.vue?vue&type=template&id=0e194ed4&scoped=true"
import script from "./our-home-base-hero.vue?vue&type=script&lang=js"
export * from "./our-home-base-hero.vue?vue&type=script&lang=js"

import "./our-home-base-hero.vue?vue&type=style&index=0&id=0e194ed4&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e194ed4"]])

export default __exports__